import { render } from "./InternalData.vue?vue&type=template&id=d24a0492&scoped=true"
import script from "./InternalData.vue?vue&type=script&lang=js"
export * from "./InternalData.vue?vue&type=script&lang=js"

import "./InternalData.vue?vue&type=style&index=0&id=d24a0492&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d24a0492"]])

export default __exports__